var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uppy)?_c('dashboard-modal',{attrs:{"uppy":_vm.uppy,"props":_vm.dashboardProps,"open":_vm.isOpen}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }